import makeStyles from "@mui/styles/makeStyles";
import { IconPanelProps } from "./IconPanel.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: IconPanelProps) => ({
    display: "flex",
    padding: 16,
    background: theme.palette.common.white,
    borderRadius: props.hasBorderRadius !== false ? 4 : 0,
  }),
  icon: (props: IconPanelProps) => ({
    marginRight: 12,
    marginTop: 4,
    "& > svg": {
      width: 20,
      height: 20,
      fill: props.color,
    },
  }),
  content: {
    flex: "1",
  },
}));
